import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import React from 'react';
import { LoadingSlugs, RoundedButton } from '@codametrix/ui-components';
import '../../apps/login/login.scss';
import PasswordChangeForm from './password-change-form';
const PasswordChange = (props)=>{
    const { handleNewPassword, handleContinue, handleNavigateHome, error, submitting, forcePasswordChange, formErrors } = props;
    if (forcePasswordChange === undefined) {
        handleNavigateHome();
    }
    if (submitting === true) {
        return /*#__PURE__*/ _jsx(LoadingSlugs, {
            numberItems: 5
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        children: !forcePasswordChange ? /*#__PURE__*/ _jsxs("div", {
            className: 'password-change-success',
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    children: "Password change successful"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: 'mx-2',
                    children: /*#__PURE__*/ _jsx("span", {
                        children: "You may now proceed to the application."
                    })
                }),
                /*#__PURE__*/ _jsx(RoundedButton, {
                    className: "btn-primary qa-continue-to-app-button mx-2 mt-2",
                    type: "submit",
                    onClick: handleContinue,
                    children: "Continue"
                })
            ]
        }) : /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h5", {
                    children: "Choose your password"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: 'mx-2',
                    children: /*#__PURE__*/ _jsx("span", {
                        children: "Your organizations administrator has requested that you change your password"
                    })
                }),
                /*#__PURE__*/ _jsx(PasswordChangeForm, {
                    includeOldPassword: true,
                    handleNewPassword: handleNewPassword,
                    handleContinue: handleContinue,
                    formErrors: formErrors,
                    error: error,
                    submitting: submitting
                })
            ]
        })
    });
};
export default PasswordChange;
